import darkUrl from "@ncom/theme/dark?url";
import whiteUrl from "@ncom/theme/white?url";
import deepblueUrl from "@ncom/theme/deepblue?url";
import purpleUrl from "@ncom/theme/purple?url";

export type ThemeKey = "dark" | "white" | "deepblue" | "purple";

export const THEME_URLS: Record<ThemeKey, string> = {
  dark: darkUrl,
  white: whiteUrl,
  deepblue: deepblueUrl,
  purple: purpleUrl,
};

export const THEME_STORAGE_KEY = "ncom-theme";

export function isThemeKey(key: string): key is ThemeKey {
  return key in THEME_URLS;
}

/** 切换全局主题：改 #theme-link，兼容开发与生产构建（?url） */
export function applyTheme(key: string) {
  const themeKey: ThemeKey = isThemeKey(key) ? key : "dark";
  let link = document.querySelector("#theme-link") as HTMLLinkElement | null;
  if (!link) {
    link = document.createElement("link");
    link.id = "theme-link";
    link.rel = "stylesheet";
    document.head.appendChild(link);
  }
  link.href = THEME_URLS[themeKey];
  try {
    localStorage.setItem(THEME_STORAGE_KEY, themeKey);
  } catch {
    /* ignore */
  }
  return themeKey;
}

export function getStoredTheme(): ThemeKey {
  try {
    const saved = localStorage.getItem(THEME_STORAGE_KEY) || "";
    if (isThemeKey(saved)) return saved;
  } catch {
    /* ignore */
  }
  return "dark";
}
